import React from 'react';
import Loading from '../components/Loading';
import Layout from './Layout';

const Styleguide = (props) => {
    let buttonsStyle = ['primary', 'danger'];
    let buttonsSize = ['sm', 'md', 'lg'];
    return (
        <Layout>
            <div className="page-styleguide">
                <section id="typography" className="spaced-double">
                    <div className="spaced-double">
                        <h2>Headings</h2>
                        <hr />
                        <h1>Header 1</h1>
                        <h2>Header 2</h2>
                        <h3>Header 3</h3>
                        <h4>Header 4</h4>
                        <h5>Header 5</h5>
                        <h6>Header 6</h6>
                    </div>
                    <h2>Body copy</h2>
                    <hr />
                    <p>
                        Lorem ipsum dolor sit amet, <a href="#typography">test link</a> adipisicing elit, sed do eiusmod
                        tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                        exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                        occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </p>
                </section>

                <section id="links" className="spaced-double">
                    <h2>Links/Anchors</h2>
                    <hr />

                    <ul>
                        <li>
                            <a href="#links">Standard</a>
                        </li>
                        <li>
                            <a href="#links" className="no-line">
                                No Line
                            </a>
                        </li>
                        <li>
                            <a href="#links" className="view-link">
                                View Brand
                            </a>
                        </li>
                        <li>
                            <a href="#links" className="important">
                                Important
                            </a>
                        </li>
                        <li>
                            <a href="#links" className="title-cta">
                                Product Title CTA <i className="pw pw-arrow-right pw-sm"></i>
                            </a>
                        </li>
                    </ul>
                </section>
                <section id="buttons" className="spaced-double">
                    <h2>Button Styles</h2>
                    <hr />
                    <div className="spaced-double">
                        {buttonsStyle.map((type) => {
                            return (
                                <button
                                    key={`button_${type}`}
                                    className={`btn btn-${type}`}
                                    style={{ marginBottom: '1em' }}
                                >{`${type} button`}</button>
                            );
                        })}
                    </div>
                    <h2>Button Sizes</h2>
                    <hr />
                    <div>
                        {buttonsSize.map((type) => {
                            return (
                                <button key={`button_${type}`} className={`btn btn-${type}`}>{`${type} button`}</button>
                            );
                        })}
                    </div>
                </section>
                <section id="lists" className="spaced-double">
                    <h2>List Types</h2>
                    <hr />

                    <h3>Unordered</h3>
                    <ul>
                        <li>lorem ipsum</li>
                        <li>dolor sit amet</li>
                        <li>adipisicing elit</li>
                    </ul>

                    <h3>Ordered</h3>
                    <ol>
                        <li>lorem ipsum</li>
                        <li>dolor sit amet</li>
                        <li>adipisicing elit</li>
                    </ol>

                    <h3>Inline</h3>
                    <ul className="list-inline">
                        <li>
                            <a href="#lists">lorem ipsum</a>
                        </li>
                        <li>
                            <a href="#lists">dolor sit amet</a>
                        </li>
                        <li>
                            <a href="#lists">adipisicing elit</a>
                        </li>
                    </ul>

                    <h3>Flat</h3>
                    <ul className="list-flat">
                        <li>
                            <a href="#lists">lorem ipsum</a>
                        </li>
                        <li>
                            <a href="#lists">dolor sit amet</a>
                        </li>
                        <li>
                            <a href="#lists">adipisicing elit</a>
                        </li>
                    </ul>
                </section>
                <section id="tables" className="spaced-double">
                    <h2>Tables</h2>
                    <hr />

                    <div>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Address</th>
                                    <th>Phone #</th>
                                    <th>Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Beatrice Patterson</td>
                                    <td>1234 Hogan St</td>
                                    <td>(199)-988-5201</td>
                                    <td>beatrice.patterson90@example.com</td>
                                </tr>
                                <tr>
                                    <td>Seth Bowman</td>
                                    <td>7323 Oak Lawn Ave</td>
                                    <td>(193)-890-7357</td>
                                    <td>seth.bowman89@example.com</td>
                                </tr>
                                <tr>
                                    <td>Calvin Coleman</td>
                                    <td>2082 E Adele St</td>
                                    <td>(989)-946-7978</td>
                                    <td>calvin.coleman25@example.com</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                <section id="loading">
                    <h2>Loading</h2>
                    <Loading />
                </section>
            </div>
        </Layout>
    );
};

export default Styleguide;
